import {monolithGet} from './fetch'

const groomRentsFree = 'groom-rents-free'

const getDiscountQualification = (discountName) => (orderId) =>
  monolithGet(`/discount/${discountName}/qualification-status/order/${orderId}`)

export const getGroomRentsFreeQualification = getDiscountQualification(groomRentsFree)
